<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" ref="table">
          <wt-table :list="tableData" :labels="historyList">
            <template>
              <slot/>
            </template>
          </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-work-order-history-table'

export default {
  name: 'pt-work-order-history-table',
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    historyList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getOrderWorkHistoryList', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
